/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  const sampleButtonApp = {
    init() {
      this.sampleButton = document.querySelector('.js-btn-sample');
      if (!this.sampleButton) return;

      this.cartDrawer = document.querySelector('cart-element[data-cart-drawer]');
      if (!this.cartDrawer) return;

      this.setupEventListeners();
    },

    setupEventListeners() {
      this.sampleButton.addEventListener('click', this.handleButtonClick.bind(this));
      document.addEventListener('theme:cart:added', this.handleSuccess.bind(this));
    },

    handleButtonClick() {
      const id = this.sampleButton.dataset.id;
      if (!id) return;

      this.sampleButton.classList.add('is-loading');

      const formData = new FormData();
      formData.append('id', id);
      formData.append('quantity', '1');

      const tempButton = document.createElement('button');
      tempButton.setAttribute('data-add-to-cart', '');
      tempButton.classList.add("hidden");
      document.body.appendChild(tempButton);

      this.cartDrawer.button = tempButton;
      this.cartDrawer.form = null;
      this.cartDrawer.recipientErrors = false;
      this.cartDrawer.variantTitle = 'Product';

      this.cartDrawer.addToCart(formData);

      this.tempButton = tempButton;
    },

    handleSuccess() {
      if (this.sampleButton) {
        this.sampleButton.classList.remove('is-loading');
      }

      if (this.tempButton && this.tempButton.parentNode) {
        this.tempButton.remove();
        this.tempButton = null;
      }
    }
  };

  sampleButtonApp.init();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.selector-wrapper--large').forEach(function(el) {
      el.classList.add('selector-wrapper--visible');
    });
  });

  setTimeout(() => {
    document.querySelectorAll('.selector-wrapper--large').forEach(function(el) {
      el.classList.add('selector-wrapper--visible');
    });
  })

}())


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.selector-wrapper--large').forEach(function(el) {
    el.classList.add('selector-wrapper--visible');
  });
});